import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import Input from '../utils/Input';
import { setAddSource, addSource } from '../../action/handbook';
import cn from 'classnames';
import ErrorContainer from '../utils/ErrorContainer';
import Switch from '../utils/Switch';

class AddSource extends Component {
    componentWillUnmount() {
        this.props.setAddSource({});
    }
    
    renderSubHeader() {
        return (
            <div className="kt-subheader not-mt kt-grid__item">
                <div className="kt-container  kt-container--fluid">
                <div className="kt-subheader__main">
                    <h3 className="kt-subheader__title">Добавить источник</h3>
                    <span className="kt-subheader__separator kt-subheader__separator--v"></span>
                    <div className="kt-subheader__group" id="kt_subheader_search">
                        <span className="kt-subheader__desc">
                            
                        </span>
                    </div>
                </div>        
                <div className="kt-subheader__toolbar">
                    <button onClick={() => this.props.history.push('/handbook/sources')} className="btn btn-default btn-bold">
                        Назад
                    </button>
                </div>
            </div>
            </div>
        );
    }

    isValidSource() {
        const { name, value } = this.props.addForm;
        if (name && value) return true;
        return false;
    }

    setSource = (field) => (e) => {
        const data = {...this.props.addForm};
        if(field !== 'isAggregator') {
            data[field] = e.target.value;
        } else {
            data[field] = e;
        }
        this.props.setAddSource(data);
    }

    onSubmit = (e) => {
        e.preventDefault();
        this.props.addSource(this.props.addForm).then(result => {
            if (result) {
                this.props.history.push('/handbook/sources');
            }
        });
    }    

    render() {
        return (
            <Fragment>
                { this.renderSubHeader() }
                <div className="kt-container kt-container--fluid  kt-grid__item kt-grid__item--fluid">                    
                <div className="kt-portlet">
                    <form onSubmit={this.onSubmit} className="kt-form">
                        <div className="kt-portlet__body">
                            <div className="row">
                                <div className="col-md-6">
                                    <Input
                                        label="Название"
                                        required={true}
                                        onChange={this.setSource('name')}
                                        value={this.props.addForm.name}
                                        placeholder="Название..."
                                    />
                                </div>
                                <div className="col-md-6">
                                    <Input
                                        label="Значение"
                                        required={true}
                                        onChange={this.setSource('value')}
                                        value={this.props.addForm.value}
                                        placeholder="Значение..."
                                    />
                                </div>
                            </div>
                            <div className='row'>
                                <div className="col-md-6">
                                    <label className="col-10 col-form-label">Агрегатор</label>
                                    <div className="col-2">
                                        <Switch 
                                            onChange={this.setSource('isAggregator')} 
                                            checked={this.props.addForm.isAggregator}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <ErrorContainer field="addSource" style={{ margin: '0 20px 20px' }} hasCloseButton={true}/>
                        <div className="kt-portlet__foot">
                            <div className="kt-form__actions">
                                <button
                                    disabled={!this.isValidSource() || this.props.loading}
                                    type="submit"
                                    className={cn({ 'btn btn-brand  kt-spinner--right kt-spinner--sm kt-spinner--light': true, 'kt-spinner': this.props.loading })}>
                                    Сохранить
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
                </div>
            </Fragment>
        );
    }
}

const mapStateToProps = state => ({
    addForm: state.handbook.add,
    loading: state.loaders.addSource
});

const mapDispatchToProps = {
    setAddSource: (data) => setAddSource(data),
    addSource: (data) => addSource(data)
}

export default connect(mapStateToProps, mapDispatchToProps)(AddSource);